import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { Mail, MapPin, Phone, Zap } from "lucide-react";
import Logoimg from "../assets/voice-ev91-logo.gif";

const companyLinks = [
  ["Home", "/"],
  ["About Us", "/about-us"],
  ["Services", "/services"],
  ["Life @ Voice", "/life-voice"],
  ["Blogs & News", "/blog"],
  ["Contact Us", "/contact-us"],
];

const policyLinks = [
  ["Privacy Policy", "/privacy-policy"],
  ["Terms & Conditions", "/terms-and-conditions"],
  ["Pricing & Refund Policy", "/pricing-and-refund-policy"],
];

const socialLinks = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/ev91/", icon: <FaLinkedinIn /> },
  { name: "Instagram", href: "https://www.instagram.com/ev91technologiespvtltd?igsh=MWJ1cG5saTRwaW5xcQ==", icon: <FaInstagram /> },
  { name: "X", href: "https://x.com/Voice12841491", icon: <FaTwitter /> },
  { name: "Facebook", href: "https://www.facebook.com/voice9380", icon: <FaFacebookF /> },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-slate-950 text-white">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-lime-300/60 to-transparent" />
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_0.8fr_0.8fr_1fr]">
          <div>
            <div className="flex items-center gap-4">
              <img src={Logoimg} alt="EV91 VOICE Logo" className="h-16 w-16 rounded-2xl bg-white object-contain p-1" />
              <div>
                <h2 className="text-2xl font-black">EV91 - VOICE</h2>
                <p className="text-sm font-bold uppercase tracking-[0.22em] text-lime-300">Electric last-mile mobility</p>
              </div>
            </div>
            <p className="mt-5 max-w-md leading-7 text-slate-300">
              Driving a greener tomorrow with EV delivery, fleet support, rentals, and city-scale logistics operations.
            </p>
            <button
              onClick={() => window.dispatchEvent(new CustomEvent("openJoinNowModal"))}
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-lime-300 px-5 py-3 font-black text-slate-950 transition hover:-translate-y-0.5 hover:bg-white"
            >
              <Zap className="h-4 w-4" />
              Get EV
            </button>
          </div>

          <div>
            <h3 className="text-sm font-black uppercase tracking-[0.22em] text-lime-300">Company</h3>
            <div className="mt-5 grid gap-3">
              {companyLinks.map(([label, to]) => (
                <Link key={to} to={to} className="text-slate-300 transition hover:text-white">
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-black uppercase tracking-[0.22em] text-lime-300">Legal</h3>
            <div className="mt-5 grid gap-3">
              {policyLinks.map(([label, to]) => (
                <Link key={to} to={to} className="text-slate-300 transition hover:text-white">
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-black uppercase tracking-[0.22em] text-lime-300">Reach Us</h3>
            <div className="mt-5 space-y-4 text-slate-300">
              <a
                href="https://maps.app.goo.gl/biZL7bLvcadgrXTE9"
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-3 transition hover:text-white"
              >
                <MapPin className="mt-1 h-5 w-5 shrink-0 text-lime-300" />
                <span>373/6, Begur - Hulimavu Rd, Classic Layout, Devarachikkana Halli, Bengaluru, Karnataka 560114</span>
              </a>
              <a href="tel:+919080973764" className="flex items-center gap-3 transition hover:text-white">
                <Phone className="h-5 w-5 text-lime-300" />
                +91 90809 73764
              </a>
              <a href="mailto:info@ev91riderz.com" className="flex items-center gap-3 transition hover:text-white">
                <Mail className="h-5 w-5 text-lime-300" />
                info@ev91riderz.com
              </a>
            </div>
            <div className="mt-6 flex gap-2">
              {socialLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.name}
                  className="grid h-11 w-11 place-items-center rounded-full border border-white/10 bg-white/8 text-slate-200 transition hover:bg-lime-300 hover:text-slate-950"
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-sm text-slate-400">
          <p>&copy; {currentYear} EV91 Technologies Pvt. Ltd.</p>
          <p className="mt-2">Bengaluru | Delhi-NCR | Mumbai | Chennai | Hyderabad</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
